import React from 'react';
import { Item } from '@/stores/canvasStore';
import { File, Download } from 'lucide-react';

interface FileCardProps {
  item: Item;
}

function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

export function FileCard({ item }: FileCardProps) {
  const content = item.content as { 
    filename?: string; 
    size?: number; 
    url?: string;
    mimeType?: string;
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (content.url) {
      window.open(content.url, '_blank');
    }
  };

  return (
    <div
      className="w-full h-full bg-card rounded-lg card-shadow p-4 flex flex-col border border-border hover:border-primary/50 transition-colors cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-primary/10 rounded-lg">
          <File className="w-6 h-6 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-foreground truncate text-sm">
            {content.filename || 'Unknown file'}
          </h3>
          <p className="text-xs text-muted-foreground">
            {formatFileSize(content.size || 0)}
          </p>
        </div>
      </div>
      
      <div className="flex-1" />
      
      <div className="flex items-center gap-1 text-xs text-primary">
        <Download className="w-3 h-3" />
        <span>Click to download</span>
      </div>
    </div>
  );
}
